/**
 * @generated SignedSource<<40b4fb3555b8eac0ba94fcbf455780ff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_Header_viewResult$data = {
  readonly " $fragmentSpreads": FragmentRefs<"hierarchyToggle_issueNavigator_HierarchyToggleItem" | "src_issueTableHideDoneToggle_HideDoneItemsToggle">;
  readonly " $fragmentType": "main_issueNavigator_Header_viewResult";
};
export type main_issueNavigator_Header_viewResult$key = {
  readonly " $data"?: main_issueNavigator_Header_viewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Header_viewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_Header_viewResult",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
    },
    {
      "kind": "FragmentSpread",
      "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
    }
  ],
  "type": "JiraIssueSearchView"
};

(node as any).hash = "98304a7101c46d56450487d906bea361";

export default node;
